import React from 'react'
import banner from '../../../images/activity/inviteNew/banner.png'

export default () => (
    <img src={banner} className="invite-banner"/>
)


// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteBanner.js